var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServingSizeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_242_5118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.39508 1.32684V4.67543C2.39508 5.20164 2.82561 5.63217 3.35182 5.63217H5.2653C5.51904 5.63217 5.76239 5.53137 5.94182 5.35195C6.12124 5.17253 6.22204 4.92918 6.22204 4.67543V1.32684",
    stroke: "#3E3E3E",
    strokeWidth: 0.861066,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.30908 1.32684V10.8942",
    stroke: "#3E3E3E",
    strokeWidth: 0.861066,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.0053 7.54565V1.32684C10.371 1.32684 9.76258 1.57884 9.31402 2.0274C8.86546 2.47596 8.61346 3.08434 8.61346 3.71869V6.58891C8.61346 7.11512 9.044 7.54565 9.5702 7.54565H11.0053ZM11.0053 7.54565V10.8942",
    stroke: "#3E3E3E",
    strokeWidth: 0.861066,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_242_5118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.4809,
    height: 11.4809,
    fill: "white",
    transform: "translate(0.959717 0.370239)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServingSizeIcon);
export default __webpack_public_path__ + "static/media/ServingSizeIcon.721e6e13cb80c3109b6bec30fc8b089a.svg";
export { ForwardRef as ReactComponent };